
import { defineComponent } from 'vue'

// employment information
interface EmploymentInfo {
  period: string,
  job: string
}

// educational information
interface EducationInfo {
  date: string,
  text: string
}

// grant information
interface GrantInfo {
  period: string,
  text: string
}

// award information
interface AwardInfo {
  date: string,
  text: string
}

// outreach information
interface OutreachInfo {
  date: string,
  text: string
}

// lecture information
interface LectureInfo {
  year: number,
  semester: string
  text: string
}

// etc information
interface EtcInfo {
  date: string,
  text: string
}

export default defineComponent({
  name: 'CVJa',
  data () {
    return {
      employments: [
        {
          period: '2025年5月-2027年8月(予定)',
          job: `国立研究開発法人 理化学研究所<br/>
          創発物性科学研究センター 量子物性理論研究グループ 客員研究員`
        },
        {
          period: '2022年9月-現在',
          job: `東京大学 大学院総合文化研究科<br/>
          広域科学専攻 相関基礎科学系 加藤雄介研究室 助教`
        },
        {
          period: '2022年10月-2025年3月',
          job: `国立研究開発法人 理化学研究所<br/>
          開拓研究本部 古崎物性理論研究室 客員研究員`
        },
        {
          period: '2020年4月-2022年8月',
          job: `国立研究開発法人 理化学研究所<br/>
          開拓研究本部 古崎物性理論研究室 特別研究員`
        },
        {
          period: '2017年4月-2020年3月',
          job: '日本学術振興会 特別研究員(DC1)'
        }
      ] as EmploymentInfo[],
      educations: [
        {
          date: '2020年3月',
          text: `京都大学 大学院理学研究科 物理学・宇宙物理学専攻 博士課程 修了<br/>
          指導教員：栁瀬 陽一 教授<br/>
          博士論文：<a href="doc/publications/thesis/phd_thesis.pdf" target="_blank">Modern classification theory of superconducting gap nodes</a>`
        },
        {
          date: '2017年3月',
          text: `京都大学 大学院理学研究科 物理学・宇宙物理学専攻 修士課程 修了<br/>
          指導教員：栁瀬 陽一 教授<br/>
          修士論文：<a href="doc/publications/thesis/ms_thesis.pdf" target="_blank">磁気多極子秩序と共存する超伝導の研究</a>`
        },
        {
          date: '2015年3月',
          text: '京都大学 理学部理学科 卒業'
        },
        {
          date: '2011年3月',
          text: '群馬県立高崎高等学校 卒業'
        }
      ] as EducationInfo[],
      grants: [
        {
          period: '2025年4月-2027年3月',
          text: `日本学術振興会 学術変革領域研究(A)「キメラ準粒子が切り拓く新物性科学」公募研究 [<a href="https://kaken.nii.ac.jp/ja/grant/KAKENHI-PUBLICLY-25H02113/" target="_blank">No. JP25H02113</a>]<br/>
          研究課題：固体中における準粒子間の角運動量変換に関する微視的理論の構築<br/>
          研究代表者：角田 峻太郎<br/>
          配分額：4,030千円 (直接経費：3,100千円，間接経費：930千円)`
        },
        {
          period: '2023年4月-2027年3月',
          text: `日本学術振興会 基盤研究(C) [<a href="https://kaken.nii.ac.jp/ja/grant/KAKENHI-PROJECT-23K03333/" target="_blank">No. JP23K03333</a>] 研究分担者<br/>
          研究課題：有機導体における分子配列と磁気秩序の協奏による新規電磁結合現象の探求<br/>
          研究代表者：妹尾 仁嗣<br/>
          配分額：4,810千円 (直接経費：3,700千円，間接経費：1,110千円)`
        },
        {
          period: '2023年4月-2026年3月',
          text: `日本学術振興会 若手研究 [<a href="https://kaken.nii.ac.jp/ja/grant/KAKENHI-PROJECT-23K13056/" target="_blank">No. JP23K13056</a>]<br/>
          研究課題：強相関・多自由度系における新奇超伝導現象の解明と提案<br/>
          研究代表者：角田 峻太郎<br/>
          配分額：4,680千円 (直接経費：3,600千円，間接経費：1,080千円)`
        },
        {
          period: '2017年4月-2020年3月',
          text: `日本学術振興会 特別研究員奨励費 [<a href="https://kaken.nii.ac.jp/ja/grant/KAKENHI-PROJECT-17J09908/" target="_blank">No. JP17J09908</a>]<br/>
          研究課題：多極子が織りなす新奇超伝導状態の探索と解明<br/>
          研究代表者：角田 峻太郎<br/>
          配分額：2,500千円 (直接経費：2,500千円)`
        }
      ] as GrantInfo[],
      awards: [
        {
          date: '2025年10月',
          text: '日本物理学会 <a href="http://www.r8.div.jps.or.jp/past_young_scientist_award.html" target="_blank">若手奨励賞(領域8)</a>'
        },
        {
          date: '2023年7月',
          text: 'International Conference on Strongly Correlated Electron Systems 2023: Best Poster Award'
        },
        {
          date: '2022年6月',
          text: 'JPSJ Papers of Editors\' Choice'
        },
        {
          date: '2022年4月',
          text: 'PTEP Editors\' Choice'
        },
        {
          date: '2019年3月',
          text: '日本物理学会 第74回年次大会 <a href="https://www.jps.or.jp/activities/awards/gakusei/2019a-student-presentation-award.php" target="_blank">学生優秀発表賞(領域8)</a>'
        },
        {
          date: '2018年3月',
          text: '「J-Physics：多極子伝導系の物理」平成29年度領域全体会議 最優秀ポスター賞'
        },
        {
          date: '2016年5月',
          text: '「J-Physics：多極子伝導系の物理」平成28年度領域全体会議 最優秀ポスター賞'
        },
        {
          date: '2015年-2017年',
          text: '日本学生支援機構第一種奨学金(博士前期課程) 特に優れた業績による返還免除'
        }
      ] as AwardInfo[],
      outreaches: [
        {
          date: '2024年5月14日',
          text: `<a href="https://www.integrated.c.u-tokyo.ac.jp/introduction/scienceclub-2/" target="_blank">駒場サイエンス倶楽部</a>「超伝導を結晶の『形』で分類する 〜物性物理と数理〜」<br/>
          (<a href="https://shuntarosumita.github.io/slides/slide_20240514.pdf" target="_blank">発表スライド</a>)`
        }
      ] as OutreachInfo[],
      lectures: [
        {
          year: 2025,
          semester: 'A1A2',
          text: `水曜日3-4限(13:00-16:40)<br/>
          基礎実験I, II(物理学) [理科一類生]・基礎物理学実験 [理科二類・三類生]<br/>
          東京大学教養学部前期課程`
        },
        {
          year: 2025,
          semester: 'S1',
          text: `各曜日3-4限(13:00-16:40) (発表会・計5回担当)<br/>
          基礎実験III(物理学) [理科一類生]<br/>
          東京大学教養学部前期課程`
        },
        {
          year: 2024,
          semester: 'A1A2',
          text: `火曜日3-4限(13:00-16:40)<br/>
          基礎実験I, II(物理学) [理科一類生]・基礎物理学実験 [理科二類・三類生]<br/>
          東京大学教養学部前期課程`
        },
        {
          year: 2024,
          semester: 'S1',
          text: `各曜日3-4限(13:00-16:40) (発表会・計5回担当)<br/>
          基礎実験III(物理学) [理科一類生]<br/>
          東京大学教養学部前期課程`
        },
        {
          year: 2023,
          semester: 'A1A2',
          text: `水曜日3-4限(13:00-16:40)<br/>
          基礎実験I, II(物理学) [理科一類生]・基礎物理学実験 [理科二類・三類生]<br/>
          東京大学教養学部前期課程`
        },
        {
          year: 2023,
          semester: 'S1',
          text: `火曜日3-4限(13:00-16:40)<br/>
          基礎実験III(物理学) [理科一類生]<br/>
          東京大学教養学部前期課程`
        },
        {
          year: 2022,
          semester: 'A1A2',
          text: `金曜日3-4限(13:00-16:40)<br/>
          基礎実験I, II(物理学) [理科一類生]・基礎物理学実験 [理科二類・三類生]<br/>
          東京大学教養学部前期課程`
        }
      ] as LectureInfo[],
      etcs: [
        {
          date: '2024年10月-2025年9月',
          text: '日本物理学会 領域8 運営委員'
        }
      ] as EtcInfo[]
    }
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'cv'
    }
  }
})
